/**
 * respaldoApi — qué asiento de Odoo respalda cada cosa que YoolPay hizo un día.
 *
 *   GET /api/respaldo-odoo?fecha=YYYY-MM-DD&psp=virtualpos
 *
 * PARA QUIÉN. Operaciones, antes de mandar la factura a la aseguradora: cada
 * movimiento y cada giro del día con su asiento, leído de Odoo en vivo. Y
 * contabilidad, para ver dónde el ledger y Odoo dicen cosas distintas.
 *
 * PREGUNTA A ODOO, NO A LA MARCA. `odoo_move_id` dice que algo se posteó alguna
 * vez; el respaldo es que ese asiento exista y esté posteado ahora. Entre las
 * dos cosas cabe un asiento pasado a borrador, uno borrado, y uno que nunca iba
 * a existir. Por eso esta llamada no se cachea: un estado viejo es exactamente
 * el problema que viene a resolver.
 *
 * SÓLO LEE. No hay POST acá y no debe haberlo: lo que se mira antes de firmar
 * no puede tener efectos. Mismo criterio que `informeApi` con su GET.
 *
 * Mismo patrón que sus hermanos: JWT de staff de Clerk, URL vía baseUrl.js
 * (same-origin → proxy api/yoolpay/api/[endpoint].js), y el error se lanza como
 * `Error(mensaje)` sin `err.status` — convención del repo (regla R30 del spec).
 *
 * @see src/services/yoolpay/conciliacionApi.js — cliente hermano
 * @see payment/api/respaldo-odoo.ts
 */
import { yoolpayBaseUrl } from './baseUrl.js';

const BASE = yoolpayBaseUrl();

const qs = (params) =>
  new URLSearchParams(
    Object.entries(params).filter(([, v]) => v != null && v !== ''),
  ).toString();

/**
 * El respaldo del día.
 *
 * Devuelve `{ fecha, cobros, giros, odooError }`, donde `cobros` y `giros`
 * traen `{ items, respaldados, pendientes, noAplica, completo }`.
 *
 * `odooError` NO es un fallo de la llamada: significa que no se pudo consultar
 * Odoo y que los veredictos no son confiables. Quien lo muestre tiene que
 * decirlo — un problema de red no se pinta igual que uno contable.
 */
export const getRespaldoDelDia = async (token, fecha, psp = 'virtualpos') => {
  const res = await fetch(`${BASE}/api/respaldo-odoo?${qs({ fecha, psp })}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  const payload = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(payload?.error || `payment respondió ${res.status}`);
  return payload;
};
